<template>
  <div v-if="dataBaseProfile.length != 0 || dataBaseStudentProfile.length != 0">
    <!-- Header Background Image -->
    <div class="profile-nav-bg mb-50" style="background-image: url('images/bg-pr-2.png')"></div>


    <!-- User Profile Card -->
    <a-card :bordered="false" class="card-profile-head" :bodyStyle="{ padding: 0 }">
      <template #title>
        <a-space size="large">
          <a-avatar :size="74" shape="square" :src="picture" style="width: 100%;height: 100px;border-radius: 10px;" />
          <div v-if="
            !this.$store.state.role.RulesUser.roles.includes('staff') &&
            !this.$store.state.role.RulesUser.roles.includes('faculty') &&
            !this.$store.state.role.RulesUser.roles.includes('pc_lecturers')
          " class="avatar-info">
            <h4 class="font-semibold m-0">{{ fullname }}</h4>
            <p class="font-web font-weight-bold">
              {{ fullnameThai }}
            </p>
          </div>
        </a-space>
      </template>
    </a-card>
    <!-- User Profile Card -->

    <!-- for staff Card -->
    <div v-if="!loadProfile">
      <!-- User Staff Card (8) & Past Performance & Development Log Section (16) -->
      <a-row v-if="
        this.$store.state.role.RulesUser.roles.includes('staff') ||
        this.$store.state.role.RulesUser.roles.includes('faculty') ||
        this.$store.state.role.RulesUser.roles.includes('pc_lecturers')
      " type="flex" :gutter="24">
        <!-- User Staff Card Column (8) -->
        <a-col :span="24" :xs="24" :lg="8" class="mb-24 card-member-col">
          <div class="card-member-center-wrapper">
            <cardmember :dataMember="dataBaseProfile" />
            <!-- Connect Google Chat Notify -->
            <div class="mt-30 text-center">
              <a-popconfirm v-if="$store.state.role.RulesUser.roles.includes('staff')" placement="bottom"
                :overlayStyle="{ width: '700px' }" @confirm="onUpdate" ok-text="Yes" cancel-text="No">
                <template slot="title">
                  <p class="mb-20 font-weight-bold text-danger">Connect Google Chat Notify</p>

                  <a-card class="mt-10 mb-10" title="วิธีเปลี่ยนให้ hri notification ไปอยู่ใน Google Chat แทน line">
                    <a-list class="font-web">
                      <a-list-item>1. ใช้เมล์มหาลัยเข้า เปิด <a target="_blank"
                          href="https://mail.google.com/chat">Google Chat</a> </a-list-item>
                      <a-list-item>2. กด <strong>Start a chat ( แชทใหม่ )</strong></a-list-item>
                      <a-list-item>3. กด <strong>Create a space ( สร้างพื้นที่ทำงาน )</strong></a-list-item>
                      <a-list-item>4. เลือก การตั้งค่าพื้นที่ทำงาน</a-list-item>
                      <a-list-item>5. แอปแสดงการผสานรวม</a-list-item>
                      <a-list-item>6. <strong>+ เพิ่มเว็บฮุค</strong> ตั้งชื่อ ได้ url แล้ว copy ไว้</a-list-item>
                      <a-list-item>
                        7. นำ url ที่ได้ ใส่แทน แล้วกด yes
                      </a-list-item>
                    </a-list>
                  </a-card>

                  <div class="mt-10 mb-10">
                    <a-input style="border: 2px solid #000000 !important;" placeholder="Line noti" size="large"
                      v-model="lineAcc" />
                  </div>

                </template>
                <a-button size="small">
                  <a-avatar shape="square" size="small" icon="user" :src="`/images/google-chat.png`"
                    class="mr-10 avatar" />
                  Connect Google Chat Notify
                </a-button>
              </a-popconfirm>
            </div>
          </div>
        </a-col>

        <!-- Past Performance & Development Log Column (16) -->
        <a-col :span="24" :xs="24" :lg="16" class="mb-24">
          <!-- 5 Fiscal Years Radio Group Selector (Master Selector) -->
          <fiscal-year-selector v-model="selectedFiscalYear" />

          <div class="mb-24">
            <cardperformance :selectedYear="selectedFiscalYear" />
          </div>
          <div>
            <carddevelopment :selectedYear="selectedFiscalYear" />
          </div>
        </a-col>
      </a-row>

      <!-- Basic, General & Other / Emergency Section (Bottom) -->
      <a-row v-if="
        this.$store.state.role.RulesUser.roles.includes('staff') ||
        this.$store.state.role.RulesUser.roles.includes('faculty') ||
        this.$store.state.role.RulesUser.roles.includes('pc_lecturers')
      " type="flex" :gutter="24">
        <!-- Basic Column -->
        <a-col :span="24" :md="8" class="mb-24">
          <!-- Basic Settings Card -->
          <cardbasic :dataBasic="dataBaseProfile" :dataWork="dataWork" />
          <!-- / Basic Card -->
        </a-col>
        <!-- / Basic Column -->

        <!-- Profile Information Column -->
        <a-col :span="24" :md="8" class="mb-24">
          <!-- Profile Information Card -->
          <cardinfo :dataInfo="dataBaseProfile" />
          <!-- / Profile Information Card -->
        </a-col>
        <!-- / Profile Information Column -->

        <!-- Other Column -->
        <a-col :span="24" :md="8" class="mb-24">
          <!-- Other Card -->
          <cardother :dataOther="dataBaseProfile" :dataProfileChief="dataProfileChief"
            :dataProfileManage="dataProfileManage" />
          <!-- / Other Card -->
        </a-col>
        <!-- / Other Column -->
      </a-row>
    </div>
    <!-- for staff Card -->

    <!-- for student Card -->
    <a-row v-if="this.$store.state.role.RulesUser.roles.includes('student')" type="flex" :gutter="24">
      <a-col :span="24" :md="8" class="mb-24">
        <studyinfo :dataStudy="dataBaseStudentProfile" />
      </a-col>
      <a-col :span="24" :md="8" class="mb-24">
        <stdbasic :dataStudyBasic="dataBaseStudentProfile" />
      </a-col>
      <a-col :span="24" :md="8" class="mb-24">
        <contact :dataContact="dataBaseStudentProfile" />
      </a-col>
    </a-row>
    <!-- for student Card -->
  </div>
</template>

<script>
import cardbasic from "./staff/cardbasic.vue";
import cardinfo from "./staff/cardinfo.vue";
import cardother from "./staff/cardother.vue";
import cardperformance from "./staff/cardperformance.vue";
import carddevelopment from "./staff/carddevelopment.vue";
import cardmember from "./staff/cardmember.vue";
import fiscalYearSelector from "./staff/fiscalYearSelector.vue";
import studyinfo from "./student/studyinfo.vue";
import stdbasic from "./student/stdbasic.vue";
import contact from "./student/contact.vue";
export default {
  components: {
    cardbasic,
    cardinfo,
    cardother,
    cardperformance,
    carddevelopment,
    cardmember,
    fiscalYearSelector,
    studyinfo,
    stdbasic,
    contact,
  },
  data() {
    return {
      selectedFiscalYear: null,
      objErrorMsg: {
        text: "",
        response: "",
        color: "",
      },
      // for staff
      loadProfile: false,
      dataBaseProfile: [],
      dataProfileChief: [],
      dataProfileManage: [],
      fullname: "",
      picture: "",
      fullnameThai: "",
      dataWork: "",
      // for student
      dataBaseStudentProfile: [],
      // line input
      loadingUpProfile: false,
      lineAcc: "",
    };
  },
  mounted() {
    if (this.$store.state.role.RulesUser.roles.includes("student")) {
      this.getStudentProfile();
    } else {
      this.loadProfile = true;
      this.getBaseProfile();
      this.getProfileChief();
      this.getProfileManage();
      this.loadProfile = false;
    }
  },
  methods: {
    async onUpdate() {
      // /staff/profile/line_notify_update/
      this.loadingUpProfile = true;
      try {
        const sendData = new FormData();
        sendData.append("line_notify", this.lineAcc);
        const response = await this.$http.post(
          "/staff/profile/line_notify_update/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 200) {
          this.lineAcc = response.data.line_notify;
          this.$notification.open({
            style: {
              backgroundColor: "#52c41a",
              color: "#ffffff",
            },
            message: function (h) {
              return h("div", [h("strong", { class: "" }, `Success`)]);
            },
            description: `Update profile success`,
          });
          this.loadingUpProfile = false;
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promble issue connect api : /staff/profile/line_notify_update/`,
        });
        this.loadingUpProfile = false;
      }
    },
    async getBaseProfile() {
      this.dataBaseProfile = [];
      try {
        const resBaseProfile = await this.$http.get(`/staff/profile/me/`);
        if (resBaseProfile.status === 200) {
          this.fullname = `${resBaseProfile.data.title.name_eng} ${resBaseProfile.data.name} ${resBaseProfile.data.surname}`;
          this.fullnameThai = `${resBaseProfile.data.title.name_thai} ${resBaseProfile.data.name_thai} ${resBaseProfile.data.surname_thai}`;
          this.picture = resBaseProfile.data.img;
          this.dataBaseProfile.push(resBaseProfile.data);
          this.diffDayWorked(resBaseProfile.data.worked);
          this.lineAcc = resBaseProfile.data.line_notify;
        } else {
          const error = new Error('Request Failed');
          error.resBaseProfile = resBaseProfile;
          error.response = resBaseProfile;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promble issue connect api : /staff/profile/me/`,
        });
      }
    },
    async getProfileChief() {
      this.dataProfileChief = [];
      try {
        const res = await this.$http.get(`/staff/profile/chief/`);
        if (res.status === 200) {
          if (this.isEmpty(res.data)) {
            this.dataProfileChief = [];
          } else {
            this.dataProfileChief.push(res.data);
          }
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataProfileChief = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promble issue connect api : /staff/profile/chief/`,
        });
      }
    },
    async getProfileManage() {
      this.dataProfileManage = [];
      try {
        const res = await this.$http.get(`/staff/profile/management/`);
        if (res.status === 200) {
          if (this.isEmpty(res.data)) {
            this.dataProfileManage = [];
          } else {
            this.dataProfileManage.push(res.data);
          }
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.dataProfileManage = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promble issue connect api : /staff/profile/management/`,
        });
      }
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    diffDayWorked(dayWork) {
      const startx = this.moment(dayWork);
      const endx = this.moment();
      const diffx = endx.diff(startx);
      const result = this.moment.duration(diffx, "milliseconds");
      this.dataWork = `${result._data.years} Year ${result._data.months} Months ${result._data.days} Day`;
    },
    async getStudentProfile() {
      this.dataBaseStudentProfile = [];
      try {
        const resStudent = await this.$http.get(`/student/profile/me/`);
        if (resStudent.status === 200) {
          this.fullname = `${resStudent.data.title} ${resStudent.data.english_first_name} ${resStudent.data.english_last_name}`;
          this.fullnameThai = `${resStudent.data.native_first_name} ${resStudent.data.native_last_name}`;
          this.picture =
            "https://icapp.muic.mahidol.ac.th/source/pic/" +
            resStudent.data.id +
            ".jpg";
          this.dataBaseStudentProfile.push(resStudent.data);
        } else {
          const error = new Error('Request Failed');
          error.resStudent = resStudent;
          error.response = resStudent;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [h("strong", { class: "" }, `Error`)]);
          },
          description: `Promble issue connect api : /student/profile/me`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-member-col {
  display: flex;
  flex-direction: column;
}

.card-member-center-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 100%;
}
</style>